import React from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import theme from '../theme';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  overflow-y: auto;
`;

const PopupContainer = styled(motion.div)`
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-radius: ${props => props.theme.borderRadius.large};
  padding: 48px 32px 32px 32px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(205, 255, 155, 0.3);
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, ${props => props.theme.colors.secondary} 0%, #e8316d 100%);
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(219, 39, 98, 0.3);
  &:hover {
    background: linear-gradient(135deg, #e8316d 0%, ${props => props.theme.colors.secondary} 100%);
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(219, 39, 98, 0.4);
  }
  &:active {
    transform: scale(0.95);
  }
`;

const PopupTitle = styled.h2`
  font-size: 26px;
  background: linear-gradient(135deg, ${props => props.theme.colors.primary} 0%, ${props => props.theme.colors.secondary} 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 18px;
  text-align: center;
  font-weight: 700;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 38px;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, ${props => props.theme.colors.accent1} 50%, transparent 100%);
  }
`;

const Message = styled.div`
  color: ${props => props.theme.colors.primary};
  font-size: 1.15rem;
  text-align: center;
  margin-bottom: 32px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
`;

const ActionButton = styled.button`
  padding: 12px 32px;
  background: linear-gradient(135deg, ${props => props.theme.colors.secondary} 0%, #e8316d 100%);
  color: white;
  border: none;
  border-radius: ${props => props.theme.borderRadius.medium};
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  &:hover {
    background: linear-gradient(135deg, #e8316d 0%, ${props => props.theme.colors.secondary} 100%);
    transform: scale(1.07);
  }
  &:active {
    transform: scale(0.96);
  }
`;

const CancelButton = styled(ActionButton)`
  background: #eee;
  color: ${props => props.theme.colors.primary};
  &:hover {
    background: #f5f5f5;
    color: ${props => props.theme.colors.secondary};
    transform: scale(1.07);
  }
`;

const LogoutPopup = ({ isOpen, onClose, onLogout }) => (
  <AnimatePresence>
    {isOpen && (
      <Overlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        onClick={onClose}
      >
        <PopupContainer
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.95, opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
          onClick={e => e.stopPropagation()}
        >
          <CloseButton onClick={onClose}>×</CloseButton>
          <PopupTitle>Logout</PopupTitle>
          <Message>Möchtest du dich wirklich ausloggen?</Message>
          <ButtonRow>
            <CancelButton onClick={onClose}>Abbrechen</CancelButton>
            <ActionButton onClick={onLogout}>Logout</ActionButton>
          </ButtonRow>
        </PopupContainer>
      </Overlay>
    )}
  </AnimatePresence>
);

export default LogoutPopup; 